import { initPayrollTour } from './payroll-tour.js';

class App {
    init() {
        this.initComponents(), this.initPortletCard(), this.initMultiDropdown(), this.initFormValidation(), this.initToggle(), this.initDismissible(), this.initLeftSidebar(), this.initTopbarMenu()
    }

    initComponents() {
        // Use window.lucide to ensure it's available
        if (typeof window.lucide !== 'undefined' && typeof window.lucide.createIcons === 'function') {
            window.lucide.createIcons();
        }
        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(e => {
            new bootstrap.Popover(e)
        }), document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(e => {
            new bootstrap.Tooltip(e)
        }), document.querySelectorAll(".offcanvas").forEach(e => {
            new bootstrap.Offcanvas(e)
        }), document.querySelectorAll(".toast").forEach(e => {
            new bootstrap.Toast(e)
        }), this.initProfilePictureUpload()
    }

    initPortletCard() {
        $('[data-action="card-close"]').on("click", function (e) {
            e.preventDefault();
            let t = $(this).closest(".card");
            t.fadeOut(300, function () {
                t.remove()
            })
        }), $('[data-action="card-toggle"]').on("click", function (e) {
            e.preventDefault();
            var e = $(this).closest(".card"), t = $(this).find("i").eq(0), a = e.find(".card-body"),
                i = e.find(".card-footer");
            a.slideToggle(300), i.slideToggle(200), t.toggleClass("ti-chevron-up ti-chevron-down"), e.toggleClass("card-collapse")
        });
        var e = document.querySelectorAll('[data-action="card-refresh"]');
        e && e.forEach(function (e) {
            e.addEventListener("click", function (e) {
                e.preventDefault();
                var t, e = e.target.closest(".card");
                let a = e.querySelector(".card-overlay");
                a || ((a = document.createElement("div")).classList.add("card-overlay"), (t = document.createElement("div")).classList.add("spinner-border", "text-primary"), a.appendChild(t), e.appendChild(a)), a.style.display = "flex", setTimeout(function () {
                    a.style.display = "none"
                }, 1500)
            })
        }), $('[data-action="code-collapse"]').on("click", function (e) {
            e.preventDefault();
            var e = $(this).closest(".card"), t = $(this).find("i").eq(0);
            e.find(".code-body").slideToggle(300), t.toggleClass("ti-chevron-up ti-chevron-down")
        })
    }

    initMultiDropdown() {
        $(".dropdown-menu a.dropdown-toggle").on("click", function () {
            var e = $(this).next(".dropdown-menu"), e = $(this).parent().parent().find(".dropdown-menu").not(e);
            return e.removeClass("show"), e.parent().find(".dropdown-toggle").removeClass("show"), !1
        })
    }

    initFormValidation() {
        document.querySelectorAll(".needs-validation").forEach(t => {
            t.addEventListener("submit", e => {
                t.checkValidity() || (e.preventDefault(), e.stopPropagation()), t.classList.add("was-validated")
            }, !1)
        })
    }

    initProfilePictureUpload() {
        const fileInput = document.getElementById('profile_picture');
        if (fileInput) {
            fileInput.addEventListener('change', function(e) {
                const file = e.target.files[0];
                if (file) {
                    // Validate file type
                    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                    if (!allowedTypes.includes(file.type)) {
                        alert('Please select a valid image file (JPEG, PNG, JPG, or GIF).');
                        this.value = '';
                        return;
                    }

                    // Validate file size (2MB)
                    if (file.size > 2 * 1024 * 1024) {
                        alert('File size must be less than 2MB.');
                        this.value = '';
                        return;
                    }

                    // Show preview
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        const previewContainer = document.querySelector('.avatar-lg');
                        if (previewContainer) {
                            previewContainer.innerHTML = `<img src="${e.target.result}" alt="Profile Picture Preview" class="rounded-circle img-thumbnail" style="width: 120px; height: 120px; object-fit: cover;">`;
                        }
                    };
                    reader.readAsDataURL(file);
                }
            });
        }
    }

    initToggle() {
        document.querySelectorAll("[data-toggler]").forEach(e => {
            let t = e.querySelector("[data-toggler-on]"), a = e.querySelector("[data-toggler-off]"),
                i = "on" === e.getAttribute("data-toggler"), s = () => {
                    i ? (t?.classList.remove("d-none"), a?.classList.add("d-none")) : (t?.classList.add("d-none"), a?.classList.remove("d-none"))
                };
            t?.addEventListener("click", () => {
                i = !1, s()
            }), a?.addEventListener("click", () => {
                i = !0, s()
            }), s()
        })
    }

    initDismissible() {
        document.querySelectorAll("[data-dismissible]").forEach(t => {
            t.addEventListener("click", () => {
                var e = t.getAttribute("data-dismissible"), e = document.querySelector(e);
                e && e.remove()
            })
        })
    }

    initLeftSidebar() {
        let o = document.querySelector(".side-nav");
        if (o) {
            o.querySelectorAll("li [data-bs-toggle='collapse']").forEach(e => {
                e.addEventListener("click", e => e.preventDefault())
            });
            let s = o.querySelectorAll("li .collapse"), e = (s.forEach(e => {
                e.addEventListener("show.bs.collapse", e => {
                    let t = e.target, a = [], i = t.parentElement;
                    for (; i && i !== o;) i.classList.contains("collapse") && a.push(i), i = i.parentElement;
                    s.forEach(e => {
                        e === t || a.includes(e) || new bootstrap.Collapse(e, {toggle: !1}).hide()
                    })
                })
            }), window.location.href.split(/[?#]/)[0]);
            o.querySelectorAll("a").forEach(t => {
                if (t.href === e) {
                    o.querySelectorAll("a.active, li.active, .collapse.show").forEach(e => {
                        e.classList.remove("active"), e.classList.remove("show")
                    }), t.classList.add("active");
                    let e = t.closest("li");
                    for (; e && e !== o;) {
                        e.classList.add("active");
                        var a = e.closest(".collapse");
                        e = a ? (new bootstrap.Collapse(a, {toggle: !1}).show(), (a = a.closest("li")) && a.classList.add("active"), a) : e.parentElement
                    }
                }
            }), setTimeout(() => {
                var e = o.querySelector("li.active .active"),
                    t = document.querySelector(".sidenav-menu .simplebar-content-wrapper");
                if (e && t) {
                    e = e.offsetTop - 300;
                    if (100 < e) {
                        var r = t;
                        t = e;
                        var l = 600;
                        let s = r.scrollTop, o = t - s, n = 0;
                        !function e() {
                            var t, a, i;
                            n += 20, r.scrollTop = (t = n, a = s, i = o, (t /= l / 2) < 1 ? i / 2 * t * t + a : -i / 2 * (--t * (t - 2) - 1) + a), n < l && setTimeout(e, 20)
                        }()
                    }
                }
            }, 200)
        }

        // Fix SimpleBar scrolling when navigation expands/collapses
        this.fixSimpleBarScrolling();
    }

    fixSimpleBarScrolling() {
        const sidebar = document.querySelector('.sidenav-menu');
        const scrollContainer = document.querySelector('.sidenav-menu [data-simplebar]');

        if (!sidebar || !scrollContainer) return;

        // Get SimpleBar instance
        const simpleBarInstance = SimpleBar.instances.get(scrollContainer);

        if (!simpleBarInstance) {
            // Initialize SimpleBar if not already initialized
            new SimpleBar(scrollContainer);
        }

        // Function to update SimpleBar
        const updateSimpleBar = () => {
            if (simpleBarInstance) {
                simpleBarInstance.recalculate();
            }
        };

        // Listen for Bootstrap collapse events
        const collapseElements = document.querySelectorAll('.sidenav-menu .collapse');
        collapseElements.forEach(collapse => {
            collapse.addEventListener('shown.bs.collapse', () => {
                setTimeout(updateSimpleBar, 350); // Wait for animation to complete
            });

            collapse.addEventListener('hidden.bs.collapse', () => {
                setTimeout(updateSimpleBar, 350); // Wait for animation to complete
            });
        });

        // Force SimpleBar update on window resize
        window.addEventListener('resize', () => {
            setTimeout(updateSimpleBar, 100);
        });

        // Ensure scrollbar is visible when content overflows
        const ensureScrollbarVisibility = () => {
            const contentWrapper = document.querySelector('.sidenav-menu .simplebar-content-wrapper');
            const content = document.querySelector('.sidenav-menu .simplebar-content');

            if (contentWrapper && content) {
                const isOverflowing = content.scrollHeight > contentWrapper.clientHeight;

                if (isOverflowing) {
                    // Force scrollbar to be visible
                    const scrollbar = document.querySelector('.sidenav-menu .simplebar-scrollbar');
                    if (scrollbar) {
                        scrollbar.style.opacity = '1';
                        scrollbar.style.visibility = 'visible';
                    }
                }
            }
        };

        // Check for overflow on page load
        setTimeout(ensureScrollbarVisibility, 500);

        // Check for overflow when navigation changes
        const observer = new MutationObserver(() => {
            setTimeout(ensureScrollbarVisibility, 100);
        });

        observer.observe(sidebar, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    initTopbarMenu() {
        var i = document.querySelector(".navbar-nav");
        if (i) {
            let t = window.location.href.split(/[?#]/)[0];
            i.querySelectorAll("li a").forEach(e => {
                if (e.href === t) {
                    e.classList.add("active");
                    let t = e.parentElement;
                    for (let e = 0; e < 6 && t && t !== document.body; e++) "LI" !== t.tagName && !t.classList.contains("dropdown") || t.classList.add("active"), t = t.parentElement
                }
            });
            let e = document.querySelector(".navbar-toggle"), a = document.getElementById("navigation");
            e && a && e.addEventListener("click", () => {
                e.classList.toggle("open"), "block" === a.style.display ? a.style.display = "none" : a.style.display = "block"
            })
        }
    }
}

class LayoutCustomizer {
    constructor() {
        this.html = document.documentElement;
        this.config = {};
        this.eventHandlers = new Map();
    }

    init() {
        this.initConfig();
        this.initSwitchListener();
        this.initWindowSize();
        this._adjustLayout();
        this.setSwitchFromConfig();
        this.openCustomizer();
    }

    initConfig() {
        this.defaultConfig = JSON.parse(JSON.stringify(window.defaultConfig));
        this.config = JSON.parse(JSON.stringify(window.config));
        this.setSwitchFromConfig();
    }

    isFirstVisit() {
        if (!localStorage.getItem("__user_has_visited__")) {
            localStorage.setItem("__user_has_visited__", "true");
            return true;
        }
        return false;
    }

    openCustomizer() {
        const customizer = document.getElementById("theme-settings-offcanvas");
        if (customizer && this.isFirstVisit()) {
            const offcanvas = new bootstrap.Offcanvas(customizer);
            setTimeout(() => offcanvas.show(), 1000);
        }
    }

    changeLeftbarSize(size, updateConfig = true) {
        this.html.setAttribute("data-sidenav-size", size);
        if (updateConfig) {
            this.config.sidenav.size = size;
            this.setSwitchFromConfig();
        }
    }

    setSwitchFromConfig() {
        const config = this.config;
        sessionStorage.setItem("__INSPINIA_CONFIG__", JSON.stringify(config));

        // Reset all checkboxes
        document.querySelectorAll(".right-bar input[type=checkbox]").forEach(input => {
            input.checked = false;
        });

        // Set sidebar user checkbox
        const sidebarUserInput = document.querySelector('input[name="sidebar-user"]');
        if (sidebarUserInput) {
            sidebarUserInput.checked = config.sidenav.user === true;
        }

        // Set radio buttons
        const configMap = [
            ["data-skin", config.skin],
            ["data-bs-theme", config.theme],
            ["data-layout-position", config.layout.position],
            ["data-topbar-color", config.topbar.color],
            ["data-menu-color", config.menu.color],
            ["data-sidenav-size", config.sidenav.size]
        ];

        configMap.forEach(([name, value]) => {
            const input = document.querySelector(`input[name="${name}"][value="${value}"]`);
            if (input) {
                input.checked = true;
            }
        });
    }

    initSwitchListener() {
        // Remove existing listeners
        this.cleanupEventListeners();

        // Sidenav toggle
        const sidenavToggle = document.querySelector(".sidenav-toggle-button");
        if (sidenavToggle) {
            this.addClickListener(sidenavToggle, () => this._toggleSidebar());
        }

        // Close offcanvas
        const closeOffcanvas = document.querySelector(".button-close-offcanvas");
        if (closeOffcanvas) {
            this.addClickListener(closeOffcanvas, () => {
                this.html.classList.remove("sidebar-enable");
                this.hideBackdrop();
            });
        }

        // Hover buttons
        document.querySelectorAll(".button-on-hover").forEach(button => {
            this.addClickListener(button, () => {
                const currentSize = this.html.getAttribute("data-sidenav-size");
                this.changeLeftbarSize(
                    currentSize === "on-hover-active" ? "on-hover" : "on-hover-active",
                    true
                );
            });
        });
    }

    addClickListener(element, callback) {
        const handler = () => callback();
        element.addEventListener("click", handler);
        this.eventHandlers.set(element, handler);
    }

    cleanupEventListeners() {
        this.eventHandlers.forEach((handler, element) => {
            element.removeEventListener("change", handler);
            element.removeEventListener("click", handler);
        });
        this.eventHandlers.clear();
    }

    _toggleSidebar() {
        const currentSize = this.html.getAttribute("data-sidenav-size");
        const configSize = this.config.sidenav.size;

        if (currentSize === "offcanvas") {
            this.showBackdrop();
        } else if (configSize === "compact") {
            this.changeLeftbarSize(currentSize === "condensed" ? "compact" : "condensed", false);
        } else {
            this.changeLeftbarSize(currentSize === "condensed" ? "default" : "condensed", true);
        }
        this.html.classList.toggle("sidebar-enable");
    }

    showBackdrop() {
        const backdrop = document.createElement("div");
        backdrop.id = "custom-backdrop";
        backdrop.className = "offcanvas-backdrop fade show";
        document.body.appendChild(backdrop);
        document.body.style.overflow = "hidden";

        if (window.innerWidth > 767) {
            document.body.style.paddingRight = "15px";
        }

        this.addClickListener(backdrop, () => {
            this.html.classList.remove("sidebar-enable");
            this.hideBackdrop();
        });
    }

    hideBackdrop() {
        const backdrop = document.getElementById("custom-backdrop");
        if (backdrop) {
            document.body.removeChild(backdrop);
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
        }
    }

    _adjustLayout() {
        const width = window.innerWidth;
        const configSize = this.config.sidenav.size;

        if (width <= 767.98) {
            this.changeLeftbarSize("offcanvas", false);
        } else if (width <= 1140 && !["offcanvas"].includes(configSize)) {
            this.changeLeftbarSize("condensed", false);
        } else {
            this.changeLeftbarSize(configSize);
        }
    }

    initWindowSize() {
        window.addEventListener("resize", () => this._adjustLayout());
    }
}

// Export the initialization function
export function initializeApp() {
    // Ensure DOM is ready and lucide is available
    function init() {
        // Check if lucide is available
        if (typeof window.lucide === 'undefined' && typeof lucide !== 'undefined') {
            window.lucide = lucide;
        }

        (new App).init();
        window.layoutCustomizer = new LayoutCustomizer();
        window.layoutCustomizer.init();
        initPayrollTour();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}
